module.exports = __webpack_public_path__ + "陈沛泉-289fba31.png";